module.exports = __webpack_public_path__ + "static/04-car-3 1-acc02da2f3f239e796fe6c6b52ecfe0f.svg";